export default {
  SPEECH_THERAPIST: 'Logopeda',
  PEDAGOGUE: 'Pedagog',
  PSYCHIATRIST: 'Psychiatra',
  PSYCHOLOGIST: 'Psycholog',
  STUDENT: 'Student',
  NONE: 'Brak specjalizacji',
};
